/* ============
 * All Deposit Systems
 * ============
 *
 * All deposit systems.
 */

import Vue from 'vue';
import store from './../../store';
import depositSystemTransformer from './../../transformers/depositSystem';

const success = ({ data }, resolve) => {
  const depositSystems = depositSystemTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllDepositSystems', depositSystems);
  store.dispatch('setNullDepositSystem');
  resolve();
};

const failed = () => {};

// Display the deposit systems.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('deposit_systems')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/depositSystem/all.js